import { Component, Prop, Vue } from 'vue-property-decorator';
import MDTextField from '@/components/Validation/MDTextField';
import template from './MDTextFieldWithValidation.vue';

@Component({
	mixins: [template],
	components: {
		MDTextField
	}
})
export default class MDTextFieldWithValidation extends Vue {
	@Prop() rules!: any;

	@Prop() value!: any;

	@Prop() name!: string;

	@Prop() vid!: any;

	@Prop() type!: any;

	@Prop() placeholder!: any;

	@Prop() disabled!: any;

	@Prop() label!: any;

	@Prop() autocomplete!: any;

	@Prop() prependInnerIcon!: any;

	@Prop() hint!: any;

	@Prop() counter!: any;

	@Prop() maxlength!: any;

	@Prop() readonly!: boolean;

	@Prop() clearable!: boolean;

	@Prop() loading!: boolean;

	@Prop() persistentHint!: boolean;

	@Prop() persistentPlaceholder!: boolean;

	@Prop() suffix!: any;

	@Prop() prefix!: any;

	get innerValue(): string {
		return this.value;
	}

	set innerValue(val) {
		this.$emit('input', val);
	}

	emitFocus(): void {
		this.$emit('emitFocus');
	}

	emitClick(): void {
		this.$emit('emitClick');
	}

	emitBlur(): void {
		this.$emit('blur');
	}
}
